<template>
    <div class="grid grid-cols-1 gap-3 lg:grid-cols-2">
        <div>
            <label class="mb-1 block text-sm text-theme-muted">
                Contenido (Markdown) *
            </label>
            <textarea
                v-model="content"
                rows="10"
                placeholder="Escribe el contenido en Markdown…"
                class="w-full min-h-72 resize-y rounded-lg border border-theme-border bg-theme-input px-3 py-2 font-mono text-sm text-theme-base placeholder-theme-muted focus:outline-none focus:ring-1 focus:ring-theme-primary"
                @input="onInput"
            ></textarea>
        </div>

        <div>
            <span class="text-xs text-theme-muted">Vista previa</span>
            <div
                class="catalog-markdown mt-1 min-h-72 overflow-x-auto rounded-lg border border-theme-border bg-stack-background px-3 py-2"
                v-html="previewHtml"
            ></div>
        </div>
    </div>
</template>

<script>
import { renderMarkdown } from "@/common/markdown/renderMarkdown";

export default {
    name: "MarkdownSegmentEditor",
    model: {
        prop: "value",
        event: "input"
    },
    props: {
        value: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            content: this.value || ""
        };
    },
    computed: {
        previewHtml() {
            return renderMarkdown(this.content);
        }
    },
    watch: {
        value(newValue) {
            if (newValue !== this.content) {
                this.content = newValue || "";
            }
        }
    },
    methods: {
        onInput() {
            this.$emit("input", this.content);
        }
    }
};
</script>
